import { getYear } from "@rentiohq/shared-frontend/dist/utils/date-fns.utils";
import React from "react";
import images from "../../assets";
import { AppBanner } from "../AppBanner";
import ProfileMenu from "../ProfileMenu";
import * as S from "./Page.styles";

const YEAR = getYear(new Date());

interface IProps {
  children?: React.ReactNode;
  withScroll?: boolean;
  backgroundColor?: string;
}

const month = new Date().getMonth();
const { IMAGE_LEFT, IMAGE_RIGHT } = (() => {
  const WINTER = {
    IMAGE_LEFT: images.IMG_BACKGROUND_LEFT_1,
    IMAGE_RIGHT: images.IMG_BACKGROUND_RIGHT_1,
  };
  const SPRING = {
    IMAGE_LEFT: images.IMG_BACKGROUND_LEFT_2,
    IMAGE_RIGHT: images.IMG_BACKGROUND_RIGHT_2,
  };
  const SUMMER = {
    IMAGE_LEFT: images.IMG_BACKGROUND_LEFT_3,
    IMAGE_RIGHT: images.IMG_BACKGROUND_RIGHT_3,
  };

  const APRIL = {
    IMAGE_LEFT: images.IMG_BACKGROUND_LEFT_4,
    IMAGE_RIGHT: images.IMG_BACKGROUND_RIGHT_4,
  };
  const MAY = {
    IMAGE_LEFT: images.IMG_BACKGROUND_LEFT_5,
    IMAGE_RIGHT: images.IMG_BACKGROUND_RIGHT_5,
  };

  switch (month) {
    case 3 /* April (3) */:
      return APRIL;

    case 4 /* May (4) */:
      return MAY;

    default:
      break;
  }

  // Oct (9), nov (10), dec (11)
  if (month >= 9) {
    return WINTER;
  }

  // Jul (6), aug (7), sep (8)
  if (month >= 6) {
    return SUMMER;
  }

  // Apr (3), may (4), jun (5)
  if (month >= 3) {
    return SPRING;
  }

  // Jan (0), feb (1), mar (2)
  return WINTER;
})();

class Page extends React.Component<IProps> {
  // Render
  public render = () => (
    <S.Wrap>
      <S.BackgroundImageLeftWrap>
        <S.BackgroundImageLeft src={IMAGE_LEFT} />
      </S.BackgroundImageLeftWrap>
      <S.BackgroundImageRightWrap>
        <S.BackgroundImageRight src={IMAGE_RIGHT} />
      </S.BackgroundImageRightWrap>
      <S.InnerWrap>{this.renderContent()}</S.InnerWrap>
      {/*
      // FIXME: Connected component types
      // @ts-ignore */}
      <ProfileMenu />
    </S.Wrap>
  );

  private renderContent = () => {
    const { backgroundColor, children } = this.props;

    return (
      <S.ContentWrap backgroundColor={backgroundColor}>
        <div>
          <S.RentioLogoWrap onClick={this.handlePressRentioLogo}>
            <S.RentioLogo src={images.IMG_RENTIO_LOGO} />
          </S.RentioLogoWrap>
        </div>
        <AppBanner />
        <S.ChildrenWrap>{children}</S.ChildrenWrap>
        <div>
          <S.CopyrightWrap>
            <S.RentioCopyrightLogo src={images.IMG_RENTIO_LOGO_COPYRIGHT} />
            <S.CopyrightYear>{`© ${YEAR}`}</S.CopyrightYear>
          </S.CopyrightWrap>
        </div>
      </S.ContentWrap>
    );
  };

  // Event handlers
  private handlePressRentioLogo = () => {
    const url = "https://rentio.be";
    window.open(url, "_blank");
  };
}

// eslint-disable-next-line import/no-default-export
export default Page;
